import {GeneralInfoFormProps} from "../../../../types";
import {Form, Spin, Switch} from "antd";
import {useEffect} from "react";
import "./style.less"
import TextArea from "antd/es/input/TextArea";

const GeneralInfoForm = (props: GeneralInfoFormProps) => {
  const {generalInfoController} = props
  const {
    isLoading,
    form,
    submitButtonHandler,
    selectedGeneralInfoItem
  } = generalInfoController


  useEffect(() => {
    if (selectedGeneralInfoItem) {
      form.setFieldsValue(selectedGeneralInfoItem)
    } else {
      form.resetFields()
    }
  }, [selectedGeneralInfoItem])

  return <Spin spinning={isLoading}>
    <Form form={form} layout="vertical" className="generalInfoItem_form" onFinish={(formData) => {
      submitButtonHandler(formData)
    }}>
      <Form.Item name="title" label="Заголовок" rules={[{required: true}]}>
        <TextArea/>
      </Form.Item>
      <Form.Item name="category" label="Категорія" extra="Категорія (не обов'язкова), додається для групування декількох посилань" >
        <TextArea/>
      </Form.Item>
      <Form.Item name="link" label="Посилання" rules={[{required: true}]}>
        <TextArea/>
      </Form.Item>
      <Form.Item name="isFileLink" label="Тип посилання" rules={[{required: true}]}>
        <Switch checkedChildren="Посилання на файл" unCheckedChildren="Посилання на ресурс" />
      </Form.Item>

    </Form>
  </Spin>
}
export default GeneralInfoForm